<div
  class="menu-item menu-accordion"
  data-kt-menu-trigger="click"
  routerLinkActive="here show"
>
  <span class="menu-link">
    <span class="menu-icon">
      <app-keenicon [name]="menu.icon!" class="fs-2"></app-keenicon>
    </span>
    <span class="menu-title">{{ menu.title | translate }} </span>
    <span class="menu-arrow"></span>
  </span>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <section *ngFor="let sub_menu of menu.children!">
      <!-- Menu Section accordion with sub-menu accordion -->
      <div
        *ngIf="sub_menu.type === 'accordion'"
        class="menu-item menu-accordion"
        routerLinkActive="here show"
        data-kt-menu-trigger="click"
      >
        <span class="menu-link">
          <span class="menu-bullet">
            <span class="bullet bullet-dot"></span>
          </span>
          <span class="menu-title" [attr.data-link]="sub_menu.url"
            >{{ sub_menu.title | translate }}
          </span>
          <span class="menu-arrow"></span>
        </span>
        <div
          class="menu-sub menu-sub-accordion"
          routerLinkActive="menu-active-bg"
        >
          <div class="menu-item" *ngFor="let children of sub_menu.children">
            <app-side-menu-item [menu]="children"></app-side-menu-item>
          </div>
        </div>
      </div>

      <!-- Menu Section accordion with sub-menu item -->
      <div class="menu-item" *ngIf="sub_menu.type === 'item'">
        <app-side-menu-item [menu]="sub_menu"></app-side-menu-item>
      </div>
    </section>
  </div>
</div>
